module.exports = __webpack_public_path__ + "images/top-shanxi.png?706677532f90d49912e78fb9cf5920f0";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/top-shanxi.png
// module id = 200
// module chunks = 1